<si-card
    class="result-item"
    role="button"
    tabindex="0"
    [attr.aria-label]="'accessibility.open-search-result' | translate"
    (click)="openItem()"
    (keydown.enter)="openItem()"
    (keydown.space)="openItem(); $event.preventDefault()"
>
    <div body class="result-item__content">
        <div class="result-item__icon">
            @if (type() === ResultItemType.LOCATION && itemLocation()?.company?.isHeadquarters) {
                <si-icon icon="element-home-filled" />
            }
            @if (type() === ResultItemType.LOCATION && !itemLocation()?.company?.isHeadquarters) {
                <si-icon icon="element-building" />
            }

            @if (type() === ResultItemType.COUNTRY) {
                <si-icon icon="element-mark" />
            }
        </div>
        @if (type() === ResultItemType.LOCATION && itemLocation(); as location) {
            <div class="result-item__info">
                <div class="result-item__title">
                    {{ location.company?.nameShort }}, {{ location.address?.street }},
                    {{ location.address?.postalCode }} {{ location.address?.city }}
                </div>
                <div>{{ 'locationdata.country' | translate }}: {{ location.country?.name }}</div>
                <div>{{ location.company?.name }}</div>
                <div>{{ location.locationCode }}</div>
                <div>{{ location.company?.corporateType }}</div>
                <div>{{ location.company?.nameShort }}</div>
            </div>
        }
        @if (type() === ResultItemType.COUNTRY && itemCountry(); as country) {
            <div class="result-item__info">
                <div class="result-item__title">{{ country.name }}</div>
                <div>{{ country.continent }}</div>
                <div>{{ country.isoCode2 }}</div>
            </div>
        }
    </div>
</si-card>
